import React, { useEffect, useState } from 'react';
import getPostsByType from '../../../../api/graphql/queries/getPostsByType';
import getPostBySlug from '../../../../api/graphql/queries/getPostBySlug';
import searchPosts from '../../../../api/graphql/queries/searchPosts';
import imageModifier from '../../../../utils/imageModifier';
import DraggableListComponent from './DraggableListComponent';


const LogosRowModule = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialState = {
    type: 'LogosRowModule',
    name: '',
    arrow: true,
    slugnames: [],
    width: '',
    height: '',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [posts, setPosts] = useState([]);
  const [selectedPosts, setSelectedPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        setState(component);
        if (component.slugnames) {
          setSelectedPosts(component.slugnames);
        }
      } else {
        const componentObj = {
          id,
          component: state,
        };
        setIsLoading(false);
        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const setSelectedPostsFromDB = async (comp) => {
    // eslint-disable-next-line no-restricted-syntax
    const postsArray = [];
    for (const slug of comp.slugnames) {
      await getPostBySlug(slug)
        .then((res) => {
          postsArray.push(res.post);
        })
        .catch(err => console.log(err));
    }
    setSelectedPosts(postsArray);
  };

  const selectPostHandler = async (slugname) => {
    const componentObj = {
      id,
      component: state,
    };
    let newState = {};

    const postIndex = selectedPosts.findIndex(post => post.slugName === slugname);
    if (postIndex === -1) {
      await getPostBySlug(slugname)
        .then((res) => {
          setSelectedPosts([...selectedPosts, res.post]);
          newState = {
            ...state,
            slugnames: [...state.slugnames, res.post.slugName],
          };
          setState(newState);
        })
        .catch(err => console.log(err));
    } else {
      const newPosts = selectedPosts;
      const newSlugs = state.slugnames;
      newPosts.splice(postIndex, 1);
      newSlugs.splice(postIndex, 1);
      setSelectedPosts([...newPosts]);
      newState = {
        ...state,
        slugnames: [...newSlugs],
      };
      setState(newState);
    }
    componentObj.component = newState;

    handlerSetComponents(componentObj, index);
  };

  const searchPost = (e) => {
    const { value } = e.target;
    if (value === '') return setPosts([]);
    searchPosts(value).then((res) => {
      if (res === null) return setPosts([]);
      setPosts(res);
    });
  };

  const trimDescription = (post) => {
    let description = post.substr(0, 35);
    description = description.substr(0, Math.min(description.length, description.lastIndexOf(' ')));
    return `${description}...`;
  };

  const handlerSetSlugNames = (slugnames) => {
    const componentObj = {
      id,
      component: state,
    };
    const newState = {
      ...state,
      slugnames,
    };
    setState(newState);
    componentObj.component = newState;
    handlerSetComponents(componentObj, index);
  };

  const inputHandler = (e) => {
    const { value, name } = e.target;

    const { component } = components[index];

    const comp = {
      ...component,
      [name]: value,
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  return (
    <div className="flex justify-end flex-col">
      {/* <div className={`bg-greyFilter h-16 w-full pl-7 flex flex-col rounded-t-lg ${posts.length > 0 && 'rounded-tr-lg rounded-b-none'}`}>
        <p className="text-xs uppercase pl-1 text-black font-americaMonoRegular mb-0 mt-0">Search</p>
        <input className="rounded-full pr-4 pl-9 py-2 mr-4 outline-none" type="text" onChange={searchPost} />
        <span className="font-icon icon-search z-5 text-black absolute mt-7 ml-3 text-sm" />
      </div>
      <div>
        {posts && posts.length > 0 ? (
          <div>
            <p className="font-americaMonoBold text-xs uppercase py-1 bg-greyFilter rounded-t-lg mr-4 ml-6 pl-5 mt-3 mb-0">Available posts</p>
            <div className="max-h-150 overflow-auto bg-greyFilterItems rounded-b-lg ml-6 mr-4 pt-1 mb-3">
              {posts.map(
                element => element && (
                <div onClick={() => selectPostHandler(element.slugName)} key={element.slugName}>
                  <p className="text-black font-americaMonoRegular outline-none w-full pl-6 mt-1">{element.slugName}</p>
                </div>
                ),
              )}
            </div>
          </div>
        ) : null}
      </div> */}
      <div>
        {(!isLoading || selectedPosts.length) && <DraggableListComponent components={selectedPosts} handlerSetComponentsInParent={handlerSetSlugNames} />}
      </div>
    </div>
  );
};

export default LogosRowModule;
